import Vue from 'vue'

export const BUS = new Vue()
